import React, { forwardRef, useContext, useState, useRef, useEffect } from 'react';
import {
    Container,
    FilterMainText,
    FilterSelectDiv,
    FilterSelectInput,
    FilterSelectImg,
    ApplyFilterButton,
    DropdownOption,
    DropdownContainer
} from './style';
import TableFiltersContext from '../../../contexts/TableFiltersContext';
import down from '../../../assets/stock/FilterMenu/angle-down.svg';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface FreightFiltersMenuProps {
}

const FreightFiltersMenu = forwardRef<HTMLDivElement, FreightFiltersMenuProps>((props, forwardRef) => {
    const context = useContext(TableFiltersContext);

    if (!context) {
        console.error('TableFiltersContext not found. Ensure TableFiltersProvider is used.');
        return null;
    }

    const [fieldsDropdownOpen, setFieldsDropdownOpen] = useState<boolean>(false);
    const [filtersDropdownOpen, setFiltersDropdownOpen] = useState<boolean>(false);
    const [selectedField, setSelectedField] = useState<string>('');
    const [selectedFilterType, setSelectedFilterType] = useState<string>('');

    const fieldsRef = useRef<HTMLDivElement>(null);
    const filtersRef = useRef<HTMLDivElement>(null);

    const freightFilterableFields = ['Status']; 

    const statusFilterOptions = [
        'Endereço pendente',
        'A programar',
        'Rota programada',
        'Entregue',
        'Coletado'
    ];

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        if (name === 'field') {
            setSelectedField(value);
            setSelectedFilterType('');
        } else if (name === 'filterType') {
            setSelectedFilterType(value);
        } 
    };

    const handleNewField = (value: string) => {
        setSelectedField(value);
        setFieldsDropdownOpen(false);
        setSelectedFilterType(''); 
    };

    const handleNewFilterType = (value: string) => {
        setSelectedFilterType(value);
        setFiltersDropdownOpen(false);
    };

    const submitFilter = () => {
        if (!selectedField || !selectedFilterType) {
            alert("Por favor, selecione um campo e um tipo de filtro!");
            return;
        }
        
        if (selectedField === 'Status') {
            context.setFreightStatusFilter(selectedFilterType);
        } 

        setSelectedField('');
        setSelectedFilterType('');
    };

    const FilterInputComponent: React.FC = () => {
        if (!selectedField) {
            return (
                <FilterSelectDiv>
                    <FilterSelectInput
                        placeholder='Preencha acima'
                        disabled
                    />
                </FilterSelectDiv>
            );
        }
        
        return (
            <FilterSelectDiv>
                <FilterSelectInput
                    placeholder='Tipo de filtro'
                    name='filterType'
                    value={selectedFilterType}
                    onChange={handleChange}
                    onClick={() => setFiltersDropdownOpen(true)}
                    autoComplete="off"
                />
                <FilterSelectImg src={down} alt='Down arrow' onClick={() => setFiltersDropdownOpen(!filtersDropdownOpen)}/>
                {filtersDropdownOpen ? (
                    <DropdownContainer ref={filtersRef}>
                        {statusFilterOptions.map(type => (
                            <DropdownOption key={type} onClick={() => handleNewFilterType(type)}>
                                {type}
                            </DropdownOption>
                        ))}
                    </DropdownContainer>
                ) : null}
            </FilterSelectDiv>
        );
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (fieldsRef.current && !fieldsRef.current.contains(event.target as Node)) {
                setFieldsDropdownOpen(false);
            }
            if (filtersRef.current && !filtersRef.current.contains(event.target as Node)) {
                setFiltersDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Container ref={forwardRef}>
            <FilterMainText>Filtrar</FilterMainText>

            <FilterSelectDiv>
                <FilterSelectInput
                    placeholder='Filtrar por'
                    name='field'
                    value={selectedField}
                    onChange={handleChange}
                    onClick={() => setFieldsDropdownOpen(true)}
                    autoComplete="off"
                />
                <FilterSelectImg src={down} alt='Down arrow' onClick={() => setFieldsDropdownOpen(!fieldsDropdownOpen)}/>
                {fieldsDropdownOpen ? (
                    <DropdownContainer ref={fieldsRef}>
                        {freightFilterableFields.map(field => ( 
                            <DropdownOption key={field} onClick={() => handleNewField(field)}>
                                {field}
                            </DropdownOption>
                        ))}
                    </DropdownContainer>
                ) : null}
            </FilterSelectDiv>
            <FilterInputComponent/>

            <ApplyFilterButton onClick={submitFilter}>Aplicar filtro</ApplyFilterButton>
        </Container>
    );
});

FreightFiltersMenu.displayName = "FreightFiltersMenu";

export default FreightFiltersMenu;